module.exports = __webpack_public_path__ + "src/images/products/active/14_Heritage Tank, Collegiate Crest.png";